import React from 'react';
import classNames from 'classnames';
import css from './Step.module.css';

type Props = {
  className?: string;
  number: number;
  title?: string;
  hideLine?: boolean;
};

export const Step: React.FC<Props> = ({
  className,
  number,
  title,
  children,
  hideLine,
}) => {
  return (
    <div className={classNames(className, css.container)}>
      <span className={css.step}>
        <span className={css.circle}>
          <span className={css.number}>{number}</span>
        </span>
        {!hideLine && <span className={css.line} />}
      </span>

      {title && <span className={css.title}>{title}</span>}

      {children}
    </div>
  );
};
